import HttpService from "./HttpService";
const API_ENDPOINT = "/logo";

const LogoService = {
  async fetchLogo() {
    try {
      const response = await HttpService.get(`${API_ENDPOINT}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async changeLogo(data) {
    try {
      const response = await HttpService.post(`${API_ENDPOINT}`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          // Add any other headers if required
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async resetLogo(id) {
    try {
      const response = await HttpService.delete(`${API_ENDPOINT}/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default LogoService;
